import React from 'react';

interface DocumentFiltersProps {
  search: string;
  purpose: string;
  jurisdiction: string;
  assignee: string;
  state: string;
  updatedFrom: string;
  signatureStatus: string;
  missingInput: boolean;
  generationFailure: boolean;
  archived: boolean;
  onSearch: (value: string) => void;
  onFilter: (key: string, value: string | boolean) => void;
}

const DocumentFilters: React.FC<DocumentFiltersProps> = ({
  search,
  purpose,
  jurisdiction,
  assignee,
  state,
  updatedFrom,
  signatureStatus,
  missingInput,
  generationFailure,
  archived,
  onSearch,
  onFilter,
}) => (
  <div className="admin-legal-filters admin-legal-filters--documents" role="search" aria-label="Document package filters">
    <label className="admin-legal-search">Search document packages
      <input type="search" value={search} onChange={(event) => onSearch(event.target.value)} />
    </label>
    <label>Package / document type
      <select value={purpose} onChange={(event) => onFilter('purpose', event.target.value)}>
        <option value="">All types</option>
        <option value="customer_contract_package">Customer contract package</option>
        <option value="data_processing_addendum">Data processing addendum</option>
      </select>
    </label>
    <label>Jurisdiction
      <input value={jurisdiction} onChange={(event) => onFilter('jurisdiction', event.target.value)} />
    </label>
    <label>Assignee
      <input value={assignee} onChange={(event) => onFilter('assignee', event.target.value)} />
    </label>
    <label>Lifecycle state
      <select value={state} onChange={(event) => onFilter('state', event.target.value)}>
        <option value="">All states</option>
        <option value="needs_input">Needs input</option>
        <option value="queued">Queued</option>
        <option value="generating">Generating</option>
        <option value="generation_failed">Generation failed</option>
        <option value="ready_for_review">Ready for review</option>
        <option value="approved">Approved</option>
        <option value="sent">Sent</option>
        <option value="partially_executed">Partially executed</option>
        <option value="executed">Executed</option>
        <option value="declined">Declined</option>
        <option value="voided">Voided</option>
        <option value="superseded">Superseded</option>
        <option value="archived">Archived</option>
      </select>
    </label>
    <label>Updated since
      <input type="date" value={updatedFrom} onChange={(event) => onFilter('updatedFrom', event.target.value)} />
    </label>
    <label>Signature status
      <select value={signatureStatus} onChange={(event) => onFilter('signatureStatus', event.target.value)}>
        <option value="">All signature states</option>
        <option value="pending">Pending</option>
        <option value="delivered">Delivered</option>
        <option value="partial">Partial</option>
        <option value="executed">Executed</option>
        <option value="declined">Declined</option>
      </select>
    </label>
    <div className="admin-legal-filter-checks">
      <label className="admin-legal-check"><input type="checkbox" checked={missingInput} onChange={(event) => onFilter('missingInput', event.target.checked)} />Missing input</label>
      <label className="admin-legal-check"><input type="checkbox" checked={generationFailure} onChange={(event) => onFilter('generationFailure', event.target.checked)} />Generation failure</label>
      <label className="admin-legal-check"><input type="checkbox" checked={archived} onChange={(event) => onFilter('archived', event.target.checked)} />Archived only</label>
    </div>
  </div>
);

export default DocumentFilters;
